export const CREATE_TOP10QUALI_GAME_COMPLETED = "top10quali/createGameCompleted";
export const GET_TOP10QUALI_BOARD_COMPLETED = "top10quali/getBoardCompleted";
export const VALIDATE_TOP10QUALI_SLOT_COMPLETED = "top10quali/validateSlotCompleted";
export const AUTOCOMPLETE_TOP10QUALI_PILOTS_COMPLETED = "top10quali/autocompletePilotsCompleted";
export const REVEAL_ALL_TOP10QUALI_COMPLETED = "top10quali/revealAllCompleted";
export const SET_TOP10QUALI_SUGGESTIONS = "top10quali/setSuggestions";
export const RESET_TOP10QUALI_STATE = "top10quali/resetState";
